import React from 'react';
import { useTranslation } from 'react-i18next';
import { getLocaleData } from '../../ui/country/countrySelector';
import Icon from '../../ui/icon/icon';
import './attendeeDetailAnswer.css';

export default function AttendeeDetailAnswer({answer = {}}) {
    const { t, i18n } = useTranslation();
    const localeData = React.useMemo(() => getLocaleData(i18n.language), [i18n]);

    const value = React.useMemo(() => {
        if (answer.type === 'divider' || answer.type === 'latitude_longitude') {
            return null;
        }
        if (!answer.value) {
            return '-';
        }
        if (answer.type === 'file') {
            return (
                <div className='neo-attendee-detail-file'>
                    <span>{t('widget.step-confirm.uploaded')}</span>
                    <Icon name='check'/>
                </div>
            )
        }
        if (answer.type === 'checkbox') {
            return t(`widget.step-confirm.${answer.value === "1" ? 'yes' : 'no'}`)
        }
        if (answer.type === 'country') {
            const countryName = new Intl.DisplayNames([localeData.lang], { type: 'region' });
            return countryName.of(answer.value);
        }
        if (answer.type === 'birthdate') {
            return new Intl.DateTimeFormat(i18n.language).format(new Date(answer.value));
        }
        return answer.value;
    }, [answer, localeData, i18n]);

    if (value === null) {
        return null;
    }

    return (
        <div className='neo-attendee-detail-item-container'>
            <>
                <dt className='neo-attendee-detail-item-key'>{answer.key}</dt>
                <dd className='neo-attendee-detail-item-value'>{value}</dd>
            </>
        </div>
    )
}
